import { otmsHttp, noPrefixHttp, bfsUserWebHttp, bigDataHttp, exportWeb, wmsHttp } from '@/utils/http/index.js'


/**
 * 获取订单列表
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8504
 */
export function fetchOrderList(data, params) {
  return otmsHttp.request({
    url: '/order/customer/page',
    method: 'post',
    data,
    params
  })
}
/**
 * 获取订单列表U订单
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8504
 */
export function unifyList(data, params) {
  return otmsHttp.request({
    url: '/unify/order/v2/transport/page',
    method: 'post',
    data,
    params,
    noEnterprise: true
  })
}

/**
 * 获取货物品类
 * 货物品类的参数固定 cargoType，不知道接口在哪里，具体参数是什么
 */
export function fetchCargoType() {
  return noPrefixHttp.request({
    url: '/hope-saas-base-web/bmsDataDictionary/selectList',
    method: 'post',
    data: {
      dictionaryType: "cargoType",
      status: 1
    }
  })
}

/**
 * 取消订单
 * @param {array} odrNos 订单号列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/6662
 */
export function cancelOrder(params) {
  return otmsHttp.request({
    url: '/oms_plus/order/cancel',
    method: 'post',
    data: params
  })
}
/**
 * 纯运输订单详情取消订单
 */
export function cancelFullOrder(params) {
  return otmsHttp.request({
    url: '/oms_plus/order/full/cancel',
    method: 'post',
    data: params
  })
}
/**
 * 取消订单U订单
 *
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9658
 */
export function cancelOrderUnify(data) {
  return otmsHttp.request({
    url: '/unify/order/v2/batch/cancel',
    method: 'post',
    data
  })
}

/**
 * 客户订单导入
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8474
 */
export function importOrder(file) {
  return exportWeb.request({
    url: '/order/customer/import',
    method: 'post',
    data: file,
  })
}
/**
 * 仓配客户订单导入
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8474
 */
export function importWareHouseOrder(file) {
  return otmsHttp.request({
    url: '/unify/order/v2/transport_warehouse/import',
    method: 'post',
    data: file,
  })
}

/**
 * 仓配(一装多卸)客户订单导入
 * https://yapi.ops.yunlizhi.cn/project/647/interface/api/23421
 */
export function importWareHouseMultiDischargeOrder(file) {
  return exportWeb.request({
    url: '/unify/order/v2/transport_warehouse/import',
    method: 'post',
    data: file,
  })
}

/**
 * 自定义导入
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16191
 */
export function templateImport(data) {
  return otmsHttp.post('/customer/template/import', data)
}

/**
 * 客户订单失败数据下载
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8476
 */
export function featchFailData(batchId) {
  return otmsHttp.request({
    url: '/order/customer/fetchFailData',
    method: 'post',
    responseType: 'blob',
    data: { batchId },
  });
}

/**
 * 获取订单详情
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/593
 */
export function featchOrderDetail(data) {
  return otmsHttp.request({
    url: '/order/customer/detail',
    method: 'post',
    data,
  });
}
/**
 * 获取订单详情U订单
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/12436
 */
export function featchOrderDetailUnify(data) {
  return otmsHttp.request({
    url: '/unify/order/v2/transport/detail',
    method: 'post',
    data,
  });
}

/**
 * 订单日志
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8558
 */
export function featchOrderLogs(data) {
  return otmsHttp.request({
    url: '/customer/order/node/log',
    method: 'post',
    data,
  });


}

/**
 * 获取派车详情
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/10200
 */
export function dispatchInfo(data) {
  return otmsHttp.post('/order/dispatch_info', data)
}

// 获取派车详情
export function batchDispatchInfo(data, moreInfo) {
  return otmsHttp.post({
    url: '/order/batch/dispatch_info',
    data,
    type: 'needDataEncrypt',
    dataEncrypt: moreInfo
  })
}

// 根据订单号查询订单详情
export function getOrderDetail(data) {
  return otmsHttp.post('/order/customer/detail', data)
}

/**
 * @description: 创建下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/8482
 */
export function createOrder(data) {
  return otmsHttp.post('/customer/order/special/batch/create', data)
}
/**
 * @description: 根据规则创建下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/44652
 */
export function createOrderByRule(data) {
  return otmsHttp.post('/unify/order/v3/create/by_config', data)
}

/**
 * @description: 编辑下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/8502
 */
export function updateOrder(data) {
  return otmsHttp.post('/customer/order/special/update', data)
}

/**
 * @description: 标准产品下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/10470
 */
export function createStandardOrder(data) {
  return otmsHttp.post('/customer/order/product/batch/create', data)
}
/**
 * @description: 多装多卸 标准产品下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/10470
 */
export function createManyStandardOrder(data) {
  return otmsHttp.post('/unify/order/v3/create', data)
}

/**
 * @description: 标准产品编辑下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/10496
 */
export function updateStandardOrder(data) {
  return otmsHttp.post('/customer/order/product/update', data)
}
/**
 * @description: 标准产品编辑下单U订单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/10496
 */
export function updateStandardOrderUnify(data) {
  return otmsHttp.post('/customer/order/product/v2/update', data)
}
/**
 * @description: 多装多卸 产品编辑下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/16063
 */
export function updateStandardEditUnify(data) {
  return otmsHttp.post('/unify/order/v3/update', data)
}

/**
 * @description: 获取站点列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8586(老接口)
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/16811(新接口)<--使用
 */
export function getStationList(data, params) {
  return otmsHttp.post('/base_plus/unify_station/es_page', data, { params })
}
export function getStationListV2(data, params) {
  return otmsHttp.post('/base_plus/use/snapshot/station/list', data, { params })
}
/**
 * @description: 获取wms站点列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10816
 */
// export function getWmsStationList(data, params) {
//   return otmsHttp.post('/base_plus/station/page', data, {params})
// }

/**
 * @description: 创建站点
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8584
 */
export function createStation(data) {
  return otmsHttp.post('/customer/station/create', data)
}

/**
 * 获取运单节点日志
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/6689
 */
export function orderLogList(data) {
  return otmsHttp.post('/order/log/list', data)
}
/**
 * 数仓 查询车辆时间段内的GPS信息
 * @param {Objcet} params
 * params = {
 *   "vehicle":"川MP3969" 需要查询的车牌,仅支持单车查询
 *    "starttime":"2019-10-08 12:00:00" 查询时间段的起始时间，格式为yyyy-mm-dd hh24:mi:ss。starttime不能比endtime大。
 *    "endtime":"2019-10-08 12:10:00" 查询时间段的结束时间，格式为yyyy-mm-dd hh24:mi:ss。starttime不能比endtime大。
 * }
 */
// export function getdinnercarmsg(params) {
//   return scHttp.get('/interface/gps/getdinnercarmsg', {},{params})
// }

/**
* 根据策略查询车辆定位信息(设备/APP)
* https://yapi.ops.yunlizhi.cn/project/286/interface/api/18973
*/
export function pubLocGps(data) {
  return bigDataHttp.post({ url: `/geo/web/anser/pub_loc_v2`, method: 'post', data });
}

/**
 * 订单导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderExport(data) {
  return otmsHttp.request({
    url: '/order/customer/export',
    method: 'post',
    data
  });
}

/**
 * 订单导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderExportUnify(data) {
  return otmsHttp.request({
    url: '/unify/order/v2/transport/customer/export',
    method: 'post',
    data
  });
}

/**
 * 订单批量删除
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderBatchDeletion(data) {
  return otmsHttp.request({
    url: '/oms_plus/customer/order/delete',
    method: 'post',
    data
  });
}
/**
 * 订单批量删除U订单
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderBatchDeletionUnify(data) {
  return otmsHttp.request({
    url: '/oms_plus/unify/order/v2/batch/delete',
    method: 'post',
    data
  });
}
/**
 * 项目查询
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/18007
 */
export function getOrganization(data, params) {
  return otmsHttp.post({
    url: '/customer/project_list',
    method: 'post',
    data,
    params
  })
}

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function projectList(data) {
  return bfsUserWebHttp.post({
    // url: '/bfs-user/account_org/organization/list',
    url: 'crm-plus/project/page',
    method: 'post',
    data,
  })
}

/**
 * 查询项目
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9210
 */
export function fetchProject(data) {
  return otmsHttp.post('/customer/organization/project/list', data)
}


/**
 * 获取客户产品(计费产品)
 *
 */
export function getInterface(data) {
  return otmsHttp.post({
    url: '/customer/product/list',
    method: 'post',
    data,
  })
}


/**
 * 非标产品 获取车型
 *
 */
export function getCarType(data) {
  return otmsHttp.post({
    url: '/tcs_plus/car/setting/list',
    method: 'post',
    data,
  })
}
/**
 * 标准产品 获取车型
 *
 */
export function getStandCarType(data) {
  return otmsHttp.post({
    url: '/guopan_miniapp/car/setting/list',
    method: 'post',
    data,
  })
}

/**
 * 标准下单 获取线路
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/7394
 */
//  export function getCarLine(data) {
//     return otmsHttp.post({
//       url: '/base_plus/line/list',
//       method: 'post',
//       data,
//     })
//   }

/**
 * 标准下单 获取线路
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10914
 */
export function getCarLine(data, params) {
  return otmsHttp.post({
    url: '/base_plus/line/page_by_customer',
    method: 'post',
    data,
    params,
  })
}

/**
 * 非乳业订单获取线路
 *
 */
export function getNoRYCarLine(data, params) {
  return otmsHttp.post({
    url: '/base_plus/line/customer_line/list',
    method: 'post',
    data,
    params,
  })
}

/**
 * 标准下单 根据线路获取站点
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10462
 */
export function getStations(data) {
  return otmsHttp.post({
    url: '/base_plus/line/stations/list',
    method: 'post',
    data,
  })
}

/**
 * 非标准下单 获取合同
 */
export function getContract(data) {
  return otmsHttp.post({
    url: '/bfs_pricing_rule/contract/cargo_owner/list',
    method: 'post',
    data,
  })
}
/**
* 非标准下单 根据合同获取要素
*/
export function getContractEntry(data) {
  return otmsHttp.post({
    url: '/bfs_pricing_rule/pricing_field/product/element/list',
    method: 'post',
    data,
  })
}

/**
 *
 * 获取同组订单数量
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/11362
 */
export function getGroupSize(data) {
  return otmsHttp.post({
    url: '/oms_plus/order/detail/group/size',
    method: 'post',
    data,
  })
}


/**
 *
 * 查看回单
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/12392
 */
export function getPictures(data) {
  return otmsHttp.post({
    url: '/unify/order/v2/transport/waybill/pictures',
    method: 'post',
    data,
  })
}

/**
 *
 * 纯运输节点日志
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/12392
 */
export function getLog(data) {
  return otmsHttp.post({
    url: '/unify/order/v2/transport/log',
    method: 'post',
    data,
  })
}

/**
 * 仓订单日志
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/12392
 */
export function getWarehouseOrderLog(data) {
  return otmsHttp.post('/unify/order/v2/warehouse/log', data);
}

/**
 * 仓订单一装多卸日志
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/23411
 */
export function getWarehouseMultiOrderLog(data) {
  return otmsHttp.post('/unify/order/v2/multi/warehouse/log', data);
}


/**
 *
 * 派车信息
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/12398
 */
export function getDispatchInfo(data, moreInfo) {
  return otmsHttp.post({
    url: '/unify/order/v2/transport/waybill/dispatch_info',
    method: 'post',
    data,
    type: 'needDataEncrypt',
    dataEncrypt: moreInfo
  })
}
/**
 *
 * 获取路径规划结果以及对应里程数
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/10616
 */
export function getDistance(data) {
  return bigDataHttp.post({
    url: '/route/plan/distance',
    method: 'post',
    data,
  })
}
/**
 *
 * 获取预计费
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/10616
 */
export function getPrice(data) {
  return otmsHttp.post({
    url: '/customer/order/price',
    method: 'post',
    data,
  })
}

/**
 *
 * 多装多卸 获取预计费
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/10616
 */
export function getManyPrice(data) {
  return otmsHttp.post({
    url: '/unify/order/v3/price',
    method: 'post',
    data,
  })
}
/**
 *
 * 获取所有初始地
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13106
 */
export function getStartAll(data) {
  return otmsHttp.get({
    url: '/tcs_plus/line/validate/station/start/all',
    method: 'post',
    data,
  })
}

/**
 * 标准下单 零担获取线路
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13108
 */
export function getZeroCarLine(data) {
  return otmsHttp.post({
    url: '/tcs_plus/line/validate/station/end/all',
    method: 'post',
    data,
  })
}
/**
 * 标准下单 多装多卸 零担获取线路
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13108
 */
export function getManyZeroCarLine(data) {
  return otmsHttp.post({
    url: '/tcs_plus/line/validate/station/end/all/batch',
    method: 'post',
    data,
  })
}


/**
 * 标准下单 零担匹配初始地
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13090
 */
export function getZeroStart(data) {
  return otmsHttp.post({
    url: '/tcs_plus/line/validate/station/start',
    method: 'post',
    data,
  })
}

/**
 * 标准下单 零担匹配目的地
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13090
 */
export function getZeroEnd(data) {
  return otmsHttp.post({
    url: '/tcs_plus/line/validate/station/end',
    method: 'post',
    data,
  })
}
/**
 * 标准下单 多装多卸 零担多个起始地匹配目的地
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/13090
 */
export function getManyZeroEnd(data) {
  return otmsHttp.post({
    url: '/tcs_plus/line/validate/station/end/batch',
    method: 'post',
    data,
  })
}

/**
 * 获取货主租户配置
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9394
 */
export function getTenantSting(data) {
  return otmsHttp.get({
    url: '/config/customer_tenant_config',
    data,
  })
}

/**
 * 获取仓合同
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/9838
 */
export function getWareHouseContract(data) {
  return otmsHttp.request({
    url: '/bfs_pricing_rule/contract/all_type/list',
    method: 'post',
    data,
  })
}


/**
 * 自定义导入配置列表
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16149
 */
export function getTemplateList(data, params) {
  return otmsHttp.post('/oms_plus/customer/template/page', data, {
    params
  })
}

/**
 * 获取结算模板
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/9838
 */
export function getNonOperating(data) {
  return otmsHttp.request({
    url: '/bfs_pricing_rule/non_operating/search',
    method: 'post',
    data,
  })
}

/**
 * 个人货主询价中，同意报价
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/9838
 */
export function bidConfirm(data) {
  return otmsHttp.request({
    url: `/unify/order/v2/carrier/bid/confirm?unifyOrderNo=${data}`,
    method: 'post',
  })
}


/**
 * 重新出价
 */
export function transportBid(data) {
  return otmsHttp.request({
    url: `/unify/order/v2/transport/bid`,
    method: 'post',
    data,
  })
}

/**
 * 同意报价
 */
export function transportBidConfirm(data) {
  return otmsHttp.request({
    url: `/unify/order/v2/transport/bid/confirm`,
    method: 'post',
    data,
  })
}

/**
 * 确认收货
 */
export function transportBidReceipt(data) {
  return otmsHttp.request({
    url: `/unify/order/v2/transport/receipt`,
    method: 'post',
    data,
  })
}


/**
 * 获取下单模板配置:
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/cat_2246
 * /config/query
 */
export function getConfig(data) {
  return otmsHttp.request({ url: '/config/query', method: 'post', data });
}


/**
 * 下载进度查询
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/16469
 */
export function progress(data) {
  return otmsHttp.request({ url: '/unify/order/v2/progress/query', method: 'post', data });
}

/* 合同货品设置查询接口
* https://yapi.ops.yunlizhi.cn/project/202/interface/api/24271
*/
export function getContractsetting(data) {
  return otmsHttp.post('/bfs_pricing_rule/contract/goods_setting/list', data)
}

/**
 * 货品品类列表
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/19265
 */
export function getLevelTree() {
  return wmsHttp.post('/warehouse_foundation/goods_level/tree')
}

/**
 * 三级品类与温区配置list查询
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/24147
 */
export function getRatio(data) {
  return otmsHttp.post('/base_plus/goods_level_config/list', data)
}

/**
 * 3级分类货品数据查询
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/24487
 */
export function getLevelquery(data) {
  return otmsHttp.post('/base_plus/sku/public/level/query', data)
}

/**
 * 手机号码保护-AXN方式
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/29288
 */
export const getVirtualPhone = (params) => {
  return otmsHttp.post('/bfs-identity/mobile/protect/axn', params);
}

/**
 * POI列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
 */
export function getPoiList(data) {
  return bfsUserWebHttp.post('/base_plus/poi/list', data)
}

/**
 * 修改订单地址
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/29702
 */
export function updateAddress(data) {
  return bfsUserWebHttp.post('/oms_plus/address/update/approval', data)
}

/**
 * 获取修改详情
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/29711
 */
export function getAddressDetail(data) {
  return bfsUserWebHttp.post('/oms_plus/address/update/detail', data)
}

/**
 * 发送验证码
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/cat_15138
 */
export function sendCode(data) {
  return otmsHttp.post('/oms_plus/address/update/send/sms', data)
}


/**
 * 自定义导入(V2版本)
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/44366
 */

export function customerCustomImport(data) {
  return exportWeb.post('/customer/import/custom_import', data)
}


/**
 * 获取下单规则，含邮件下单规则
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/cat_15138
 */
export function getRules(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/detail/list', data)
}

export function getCustInfoList(data){
  return bigDataHttp.post('/api/web/OMS/ads_cust_base_info_brand', data)
}

/**
 * 母单配置查询
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/45438
 */
export function parentMarkList(data) {
  return otmsHttp.post('/cms_plus/parent/mark/list' , data);
}


/**
 * 模板详情查询
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/16143
 */

export function customerTemplateDetail(data) {
  return otmsHttp.post('/oms_plus/customer/template/detail' , data);
}
